/* eslint-disable consistent-return */
/* eslint-disable radix */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/order */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-bitwise */
/* eslint-disable no-plusplus */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-expressions */

import { useEffect, useState, useRef, KeyboardEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'
import {
  getPredictions,
  criaBaixaEmMassa,
  getPredictionsListagemPdf,
} from '../../services/PredictionsService/getPredictions'
import { saveAs } from 'file-saver'
import 'dayjs/locale/pt-br'
import { useSales } from '../Sales/useSales'
import axios from 'axios'
import { criaPedidoEmMassa } from '../../services/CriaPedido/getCriaPedido'
import { useConfiguracoes } from '../Configuracoes/useConfiguracoes'
import { useCriarPedido } from '../../components/CriarPedido/useCriarPedido'
import { getConfiguracoesGetInstancia } from '../../services/Configuracoes/getConfiguracoes'

export const usePrediction = () => {
  const { vendedores, clients, companies, produto } = useSales()
  const arrayClientes = Array.isArray(clients)
  const arrayVendedores = Array.isArray(vendedores)
  const arrayEmpresas = Array.isArray(companies)
  const arrayProdutos = Array.isArray(produto)
  const [cancelar, setCancelar] = useState(false)
  const [prediction, setPrediction] = useState<GetPredictionsType>(
    {} as GetPredictionsType
  )
  const [currentPage, setCurrentPage] = useState(1)
  const [isLoading, setIsLoading] = useState(true)

  const navigate = useNavigate()
  const goToPage = (id: number) => {
    navigate(`/predicao/${id}`)
  }

  const startDate = dayjs()
  const dataHoje = startDate.format('DD/MM/YYYY')
  const lastDayOfMonth = dayjs().endOf('month')
  const dataFim = lastDayOfMonth.format('DD/MM/YYYY')
  const [calendarFim, setCalendarFim] = useState(dataFim)
  const [calendarInicio, setCalendarInicio] = useState(dataHoje)

  const [client, setClient] = useState<number[]>([])

  const [salesPeople, setSalesPeople] = useState<number[]>([])
  const [valueCompanieId, setValueCompanieId] = useState<number[]>([])
  const [valueProductId, setValueProductId] = useState<number[]>([])
  const [statusChecked, setStatusChecked] = useState<string[]>([])
  const [statusCheckedTodos, setStatusCheckedTodos] = useState<string[]>([])
  const [statusCheckedFiltro, setStatusCheckedFiltro] = useState<string[]>([])

  const [valueClient, setValueClient] = useState<string[]>([])
  const [valueSalesPeople, setValueSalesPeople] = useState<string[]>([])
  const [valueCompanie, setValueCompanie] = useState<string[]>([])
  const [valueProduct, setValueProduct] = useState<string[]>([])

  // Segmento do cliente e Categoria de material. Ao contrario dos filtros acima, o valor exibido no
  // select JA e o valor enviado a API, entao nao ha um "array de ids" derivado: o par de estados e
  // so selecionado (value*) x aplicado (*Filtrado), o mesmo do botao "Aplicar" dos demais filtros.
  const [valueSegmento, setValueSegmento] = useState<string[]>([])
  const [segmentoFiltrado, setSegmentoFiltrado] = useState<string[]>([])
  const [valueCategoria, setValueCategoria] = useState<string[]>([])
  const [categoriaFiltrada, setCategoriaFiltrada] = useState<string[]>([])

  const [check, setCheck] = useState<number[]>([])
  const [selectAll, setSelectAll] = useState(false)
  const [checkEmail, setCheckEmail] = useState(false)
  const [checkWhatsApp, setCheckWhatsApp] = useState(false)

  const [predicaoPagina, setPredicaoPagina] = useState('12')
  const [itensPagina, setItensPagina] = useState('12')

  const [isCriarPedidoMassa, setIsCriarPedidoMassa] = useState(false)
  const [isEnviandoMassa, setIsEnviandoMassa] = useState(false)
  // Trava sincrona contra duplo envio (o estado isEnviandoMassa so atualiza no proximo render).
  const enviandoMassaRef = useRef(false)

  const [isBaixaMassa, setIsBaixaMassa] = useState(false)
  const [isBaixandoMassa, setIsBaixandoMassa] = useState(false)
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false)
  // Trava sincrona contra duplo clique na baixa em massa.
  const baixandoMassaRef = useRef(false)

  const valueClientString = valueClient.map(id => {
    const clientName = clients.find(name => name.nome === id)
    return clientName ? clientName.id : undefined
  })
  const clientArray = valueClientString.filter(
    value => value !== undefined
  ) as number[]

  const valueSalesPeopleString = valueSalesPeople.map(id => {
    const salesPeopleName = vendedores.find(name => name.nome === id)
    return salesPeopleName ? salesPeopleName.id : undefined
  })
  const salesPeopleArray = valueSalesPeopleString.filter(
    value => value !== undefined
  ) as number[]

  const valueCompanieString = valueCompanie.map(id => {
    const companieName = companies.find(name => name.nome === id)
    return companieName ? companieName.id : undefined
  })
  const companieArray = valueCompanieString.filter(
    value => value !== undefined
  ) as number[]

  const valueProductString = valueProduct.map(id => {
    const productName = produto.find(name => name.nome === id)
    return productName ? productName.id : undefined
  })
  const productArray = valueProductString.filter(
    value => value !== undefined
  ) as number[]

  const [selectedOptionsClient, setSelectedOptionsClient] = useState<string[]>(
    []
  )
  const [selectedOptionsSalesPeople, setSelectedOptionsSalesPeople] = useState<
    string[]
  >([])
  const [selectedOptionsProdutos, setSelectedOptionsProdutos] = useState<
    string[]
  >([])
  const [selectedOptionsEmpresas, setSelectedOptionsEmpresas] = useState<
    string[]
  >([])

  const [instancia, setInstancia] = useState<GetConfiguracoesInstacia>(
    {} as GetConfiguracoesInstacia
  )

  const fetchGetInstancia = async () => {
    setIsLoading(true)
    const result = await getConfiguracoesGetInstancia()
    setIsLoading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setInstancia(result)
    }
  }

  const fetchClient = async (cancel?: any) => {
    setIsLoading(true)

    const result = await getPredictions(
      cancel,
      client,
      salesPeople,
      valueProductId,
      valueCompanieId,
      statusCheckedFiltro,
      calendarFim,
      calendarInicio,
      currentPage,
      parseInt(itensPagina),
      segmentoFiltrado,
      categoriaFiltrada
    )
    setIsLoading(false)

    if ('message' in result) {
      if (result.message === 'cancelToken') {
        ;('')
      } else {
        toast.error(result.message)
      }
    } else {
      setPrediction(result)
    }
  }

  const criaPedidosEmMassa = async () => {
    if (enviandoMassaRef.current) return
    enviandoMassaRef.current = true
    setIsEnviandoMassa(true)
    const predicaoPedidoMassaRequestDTO = {
      clientes: check,
      enviarEmail: checkEmail,
      enviarWhatsApp: checkWhatsApp,
      // Recorte de produto APLICADO na listagem. O backend redescobre os produtos de cada cliente;
      // sem mandar o recorte, o pedido sairia com itens que nao estavam na tela e a baixa seria
      // gravada para todos eles.
      produtoId: valueProductId,
      categoria: categoriaFiltrada,
    }
    const result = await criaPedidoEmMassa(predicaoPedidoMassaRequestDTO)
    if ('message' in result) {
      toast.error(result.message)
      enviandoMassaRef.current = false
      setIsEnviandoMassa(false)
      return
    }

    // Por canal mostra enviados/solicitados — a diferenca expoe falhas parciais.
    const canais: string[] = []
    if (result.emailsSolicitados > 0)
      canais.push(`${result.emailsEnviados}/${result.emailsSolicitados} e-mail`)
    if (result.whatsappSolicitados > 0)
      canais.push(
        `${result.whatsappEnviados}/${result.whatsappSolicitados} WhatsApp`
      )
    const detalheCanais = canais.length > 0 ? ` (${canais.join(', ')})` : ''
    const detalheSemEnvio =
      result.clientesSemEnvio > 0
        ? `. ${result.clientesSemEnvio} sem envio (sem contato ou produto)`
        : ''
    const msg = `${result.clientesComEnvio} de ${result.totalClientes} pedido(s) enviado(s)${detalheCanais}${detalheSemEnvio}.`

    if (result.clientesComEnvio === 0) {
      // Nenhum cliente recebeu: mantem o modal para nova tentativa.
      toast.warning(msg)
      enviandoMassaRef.current = false
      setIsEnviandoMassa(false)
      return
    }
    toast.success(msg)
    const timer = setTimeout(() => {
      window.location.reload()
    }, 1500)
    return () => clearTimeout(timer)
  }

  const handleIsBaixaMassa = () => {
    setIsBaixaMassa(!isBaixaMassa)
  }

  // Gera o PDF da listagem (um cliente por página) para os clientes do filtro atual.
  const handleGerarPdfListagem = async () => {
    setIsGeneratingPdf(true)
    const result = await getPredictionsListagemPdf(
      client,
      salesPeople,
      valueProductId,
      valueCompanieId,
      statusCheckedFiltro,
      calendarFim,
      calendarInicio,
      segmentoFiltrado,
      categoriaFiltrada
    )
    setIsGeneratingPdf(false)

    if (result instanceof Blob) {
      saveAs(result, 'predicoes.pdf')
      return
    }
    toast.error(result.message)
  }

  const criaBaixasEmMassa = async () => {
    if (baixandoMassaRef.current) return
    // Baixa exatamente os produtos exibidos na listagem: monta, por cliente selecionado,
    // as baixas a partir de prediction.content[].produtos (produtoId + proximaCompra).
    const clientesBaixa = (prediction.content || [])
      .filter(cliente => check.includes(cliente.id))
      .map(cliente => ({
        clienteId: cliente.id,
        baixas: cliente.produtos.map(prod => ({
          acertou: true,
          produtoId: prod.id,
          dataProximaCompra: prod.proximaCompra,
        })),
      }))
      .filter(cliente => cliente.baixas.length > 0)

    if (clientesBaixa.length === 0) {
      toast.warning('Nenhum produto na listagem para os clientes selecionados.')
      return
    }

    baixandoMassaRef.current = true
    setIsBaixandoMassa(true)
    const result = await criaBaixaEmMassa(clientesBaixa)
    if ('message' in result) {
      toast.error(result.message)
      baixandoMassaRef.current = false
      setIsBaixandoMassa(false)
      return
    }

    const detalheSemBaixa =
      result.clientesSemBaixa > 0
        ? `. ${result.clientesSemBaixa} sem baixa (sem produto na listagem)`
        : ''
    const msg = `Baixa realizada em ${result.clientesComBaixa} de ${result.totalClientes} cliente(s) — ${result.produtosBaixados} produto(s) baixado(s)${detalheSemBaixa}.`

    if (result.clientesComBaixa === 0) {
      // Nenhum cliente baixado: mantem o modal aberto para nova tentativa.
      toast.warning(msg)
      baixandoMassaRef.current = false
      setIsBaixandoMassa(false)
      return
    }
    toast.success(msg)
    const timer = setTimeout(() => {
      window.location.reload()
    }, 1500)
    return () => clearTimeout(timer)
  }

  const handleFiltroCliente = (event: string[]) => {
    localStorage.setItem('filtroCliente', JSON.stringify(event))
    setValueClient(event)
  }

  const handleFiltroVendedor = (event: string[]) => {
    localStorage.setItem('filtroVendedor', JSON.stringify(event))
    setValueSalesPeople(event)
  }

  const handleFiltroEmpresa = (event: string[]) => {
    localStorage.setItem('filtroEmpresa', JSON.stringify(event))
    setValueCompanie(event)
  }

  const handleFiltroProduto = (event: string[]) => {
    localStorage.setItem('filtroProduto', JSON.stringify(event))
    setValueProduct(event)
  }

  const handleClienteFiltrado = (event: number[]) => {
    localStorage.setItem('clienteFiltrado', JSON.stringify(event))
    setClient(event)
  }

  const handleVendedorFiltrado = (event: number[]) => {
    localStorage.setItem('vendedorFiltrado', JSON.stringify(event))
    setSalesPeople(event)
  }

  const handleEmpresaFiltrada = (event: number[]) => {
    localStorage.setItem('empresaFiltrada', JSON.stringify(event))
    setValueCompanieId(event)
  }

  const handleProdutoFiltrado = (event: number[]) => {
    localStorage.setItem('produtoFiltrado', JSON.stringify(event))
    setValueProductId(event)
  }

  const handleFiltroSegmento = (event: string[]) => {
    localStorage.setItem('filtroSegmentoPredicao', JSON.stringify(event))
    setValueSegmento(event)
  }

  const handleSegmentoFiltrado = (event: string[]) => {
    localStorage.setItem('segmentoFiltradoPredicao', JSON.stringify(event))
    setSegmentoFiltrado(event)
    // Volta para a primeira pagina: manter a atual poderia cair fora do novo total e mostrar uma
    // listagem vazia como se o filtro nao tivesse achado nada.
    setCurrentPage(1)
  }

  const handleFiltroCategoria = (event: string[]) => {
    localStorage.setItem('filtroCategoriaPredicao', JSON.stringify(event))
    setValueCategoria(event)
  }

  const handleCategoriaFiltrada = (event: string[]) => {
    localStorage.setItem('categoriaFiltradaPredicao', JSON.stringify(event))
    setCategoriaFiltrada(event)
    setCurrentPage(1)
  }
  const handlePredicaoPagina = () => {
    setItensPagina(predicaoPagina)
  }

  const handleIsCriarPedidoMassa = () => {
    setIsCriarPedidoMassa(!isCriarPedidoMassa)
  }

  const handleCheckboxChange = (option: string) => {
    if (option === 'TODOS') {
      if (statusChecked.includes('TODOS')) {
        setStatusChecked([])
      } else {
        setStatusChecked([])
        setStatusCheckedTodos([])

        localStorage.setItem('filtroStatus', JSON.stringify([]))
      }
    } else if (statusChecked.includes('TODOS')) {
      setStatusChecked([option])
    } else if (statusChecked.includes(option)) {
      setStatusChecked(statusChecked.filter(item => item !== option))

      statusChecked.length === 1
        ? setStatusCheckedTodos([])
        : setStatusCheckedTodos(['TODOS'])

      localStorage.setItem(
        'filtroStatus',
        JSON.stringify(statusChecked.filter(item => item !== option))
      )
    } else {
      setStatusChecked([...statusChecked, option])
      setStatusCheckedTodos(['TODOS'])
      localStorage.setItem(
        'filtroStatus',
        JSON.stringify([...statusChecked, option])
      )
    }
  }

  const handleLimparFiltros = () => {
    localStorage.setItem('dataInicio', JSON.stringify(dataHoje))
    localStorage.removeItem('filtroStatus')
    localStorage.removeItem('filtroCliente')
    localStorage.removeItem('filtroVendedor')
    localStorage.removeItem('filtroEmpresa')
    localStorage.removeItem('filtroProduto')
    localStorage.removeItem('clienteFiltrado')
    localStorage.removeItem('vendedorFiltrado')
    localStorage.removeItem('empresaFiltrada')
    localStorage.removeItem('produtoFiltrado')
    localStorage.removeItem('filtroSegmentoPredicao')
    localStorage.removeItem('segmentoFiltradoPredicao')
    localStorage.removeItem('filtroCategoriaPredicao')
    localStorage.removeItem('categoriaFiltradaPredicao')
    window.location.reload()
  }

  const [showClient, setShowClient] = useState(false)
  const [showSalesPeople, setShowSalesPeople] = useState(false)
  const [showCompanies, setShowCompanies] = useState(false)
  const [showStatus, setShowStatus] = useState(false)
  const [showProducts, setShowProducts] = useState(false)
  const [showSegmento, setShowSegmento] = useState(false)
  const [showCategoria, setShowCategoria] = useState(false)

  // Abrir um filtro fecha os demais (os paineis sao absolutos e se sobrepoem). Com a entrada de
  // Segmento e Categoria viraram 7 paineis; a lista central abaixo evita repetir o "fecha todos"
  // dentro de cada handler, que era onde faltava atualizar quando um filtro novo era acrescentado.
  const fecharTodosOsFiltros = () => {
    setShowClient(false)
    setShowSalesPeople(false)
    setShowCompanies(false)
    setShowStatus(false)
    setShowProducts(false)
    setShowSegmento(false)
    setShowCategoria(false)
  }

  const alternarFiltro = (aberto: boolean, abrir: (valor: boolean) => void) => {
    fecharTodosOsFiltros()
    abrir(!aberto)
  }

  const handleShowFilterClient = () => alternarFiltro(showClient, setShowClient)

  const handleShowFilterSalesPeople = () =>
    alternarFiltro(showSalesPeople, setShowSalesPeople)

  const handleShowFilterCompanie = () =>
    alternarFiltro(showCompanies, setShowCompanies)

  const handleShowStatus = () => alternarFiltro(showStatus, setShowStatus)

  const handleShowProduto = () => alternarFiltro(showProducts, setShowProducts)

  const handleShowSegmento = () => alternarFiltro(showSegmento, setShowSegmento)

  const handleShowCategoria = () =>
    alternarFiltro(showCategoria, setShowCategoria)

  const handleKeyClosed = (event: React.KeyboardEvent) => {
    if (event.key === 'Escape') {
      fecharTodosOsFiltros()
    }
  }

  const handleCheckboxPredicao = (id: number) => {
    setCheck(prev => {
      if (prev.includes(id)) {
        return prev.filter(item => item !== id)
      }
      return [...prev, id]
    })
  }

  const handleCheckboxPredicaoTodos = () => {
    if (selectAll) {
      setCheck([])
    } else {
      setCheck(prediction.content.map(predicao => predicao.id))
    }
    setSelectAll(!selectAll)
  }

  const handleShowCancelar = () => {
    setCancelar(!cancelar)
  }

  useEffect(() => {
    const filtroCliente = localStorage.getItem('filtroCliente')
    const filtroVendedor = localStorage.getItem('filtroVendedor')
    const filtroStatus = localStorage.getItem('filtroStatus')
    const filtroEmpresa = localStorage.getItem('filtroEmpresa')
    const filtroProduto = localStorage.getItem('filtroProduto')

    const dataFiltrada = localStorage.getItem('dataInicio')
    const clienteFiltradoLocalStorage = localStorage.getItem('clienteFiltrado')
    const vendedorFiltradoLocalStorage =
      localStorage.getItem('vendedorFiltrado')
    const empresaFiltradaLocalStorage = localStorage.getItem('empresaFiltrada')
    const produtoFiltrdoLocalStorage = localStorage.getItem('produtoFiltrado')

    if (dataFiltrada) {
      setCalendarInicio(JSON.parse(dataFiltrada))
    }

    if (filtroCliente) {
      setValueClient(JSON.parse(filtroCliente))
    }

    if (filtroVendedor) {
      setValueSalesPeople(JSON.parse(filtroVendedor))
    }

    if (filtroStatus) {
      setStatusChecked(JSON.parse(filtroStatus))
      setStatusCheckedFiltro(JSON.parse(filtroStatus))
      filtroStatus.length === 2
        ? setStatusCheckedTodos([])
        : setStatusCheckedTodos(['TODOS'])
    }

    if (filtroEmpresa) {
      setValueCompanie(JSON.parse(filtroEmpresa))
    }

    if (filtroProduto) {
      setValueProduct(JSON.parse(filtroProduto))
    }

    if (clienteFiltradoLocalStorage) {
      const cliente = JSON.parse(clienteFiltradoLocalStorage).map(
        (id: string) => parseInt(id)
      )
      setClient(cliente)
    }
    if (vendedorFiltradoLocalStorage) {
      const vendedor = JSON.parse(vendedorFiltradoLocalStorage).map(
        (id: string) => parseInt(id)
      )
      setSalesPeople(vendedor)
    }
    if (empresaFiltradaLocalStorage) {
      const empresa = JSON.parse(empresaFiltradaLocalStorage).map(
        (id: string) => parseInt(id)
      )
      setValueCompanieId(empresa)
    }
    if (produtoFiltrdoLocalStorage) {
      const produtos = JSON.parse(produtoFiltrdoLocalStorage).map(
        (id: string) => parseInt(id)
      )
      setValueProductId(produtos)
    }

    const filtroSegmento = localStorage.getItem('filtroSegmentoPredicao')
    const segmentoAplicado = localStorage.getItem('segmentoFiltradoPredicao')
    const filtroCategoria = localStorage.getItem('filtroCategoriaPredicao')
    const categoriaAplicada = localStorage.getItem('categoriaFiltradaPredicao')

    if (filtroSegmento) {
      setValueSegmento(JSON.parse(filtroSegmento))
    }
    if (segmentoAplicado) {
      setSegmentoFiltrado(JSON.parse(segmentoAplicado))
    }
    if (filtroCategoria) {
      setValueCategoria(JSON.parse(filtroCategoria))
    }
    if (categoriaAplicada) {
      setCategoriaFiltrada(JSON.parse(categoriaAplicada))
    }
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchGetInstancia()
    }, 1000)
    return () => clearTimeout(timer)
  }, [isCriarPedidoMassa])

  useEffect(() => {
    setSelectedOptionsClient(valueClient)
    setSelectedOptionsSalesPeople(valueSalesPeople)
    setSelectedOptionsEmpresas(valueCompanie)
    setSelectedOptionsProdutos(valueProduct)
  }, [valueClient, valueSalesPeople, valueCompanie, valueProduct])

  useEffect(() => {
    const source = axios.CancelToken.source()
    fetchClient(source)
    return () => {
      source.cancel('cancelToken')
    }
  }, [
    JSON.stringify({
      currentPage,
      calendarFim,
      calendarInicio,
      client,
      salesPeople,
      valueCompanieId,
      valueProductId,
      statusCheckedFiltro,
      itensPagina,
      segmentoFiltrado,
      categoriaFiltrada,
    }),
  ])

  return {
    setClient,
    setSalesPeople,
    setCalendarInicio,
    setCalendarFim,
    prediction,
    isLoading,
    fetchClient,
    goToPage,
    setCurrentPage,
    currentPage,
    handleShowFilterClient,
    handleShowFilterSalesPeople,
    showClient,
    showSalesPeople,
    handleKeyClosed,

    setSelectedOptionsClient,
    selectedOptionsSalesPeople,
    selectedOptionsClient,
    setSelectedOptionsSalesPeople,

    selectedOptionsProdutos,
    setSelectedOptionsProdutos,
    selectedOptionsEmpresas,
    setSelectedOptionsEmpresas,

    dataHoje,

    handleShowFilterCompanie,
    showCompanies,

    setValueCompanieId,
    showStatus,
    handleShowStatus,

    showProducts,
    setValueProductId,
    handleShowProduto,

    handleCheckboxChange,
    statusChecked,
    setStatusChecked,
    statusCheckedTodos,
    setStatusCheckedTodos,
    setStatusCheckedFiltro,
    statusCheckedFiltro,

    valueClient,
    setValueClient,
    valueSalesPeople,
    setValueSalesPeople,
    valueCompanie,
    setValueCompanie,
    valueProduct,
    setValueProduct,

    arrayClientes,
    arrayVendedores,
    arrayEmpresas,
    arrayProdutos,

    productArray,
    companieArray,
    salesPeopleArray,
    clientArray,

    vendedores,
    clients,
    companies,
    produto,

    handleFiltroCliente,
    handleFiltroVendedor,
    handleFiltroEmpresa,
    handleFiltroProduto,
    handleLimparFiltros,

    handleClienteFiltrado,
    handleVendedorFiltrado,
    handleEmpresaFiltrada,
    handleProdutoFiltrado,

    valueSegmento,
    setValueSegmento,
    valueCategoria,
    setValueCategoria,
    segmentoFiltrado,
    setSegmentoFiltrado,
    categoriaFiltrada,
    setCategoriaFiltrada,
    showSegmento,
    showCategoria,
    handleShowSegmento,
    handleShowCategoria,
    handleFiltroSegmento,
    handleSegmentoFiltrado,
    handleFiltroCategoria,
    handleCategoriaFiltrada,

    startDate,
    check,
    setCheck,
    handleCheckboxPredicao,
    handleCheckboxPredicaoTodos,
    selectAll,
    predicaoPagina,
    setPredicaoPagina,
    handlePredicaoPagina,
    setCheckWhatsApp,
    setCheckEmail,
    checkWhatsApp,
    checkEmail,
    criaPedidosEmMassa,
    isEnviandoMassa,
    handleIsCriarPedidoMassa,
    isCriarPedidoMassa,

    isBaixaMassa,
    handleIsBaixaMassa,
    criaBaixasEmMassa,
    isBaixandoMassa,

    handleGerarPdfListagem,
    isGeneratingPdf,

    cancelar,
    handleShowCancelar,
    instancia,
  }
}
